module.exports = __webpack_public_path__ + "static/img/kawachi_05.f65e1ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/kawachi_05.jpg
// module id = T2W/
// module chunks = 0